import { type Href } from 'expo-router';
import { type ReactNode } from 'react';
import { Pressable, Text as RNText, View } from 'react-native';

import { Chevron } from '@/components/ui/Chevron';
import { Linkable } from '@/components/ui/Linkable';
import { Text } from '@/components/ui/Text';

export interface SettingsRowProps {
  label: string;
  /** Mono value caption on the right. */
  value?: string;
  right?: ReactNode;
  /** Navigation target — renders a real `<a href>` on web (cmd/middle-click, etc.). */
  href?: Href;
  onPress?: () => void;
  chevron?: boolean;
}

export function SettingsRow({
  label,
  value,
  right,
  href,
  onPress,
  chevron = true,
}: SettingsRowProps) {
  return (
    <Linkable href={href}>
      <Pressable
        onPress={onPress}
        className="flex-row items-center justify-between px-4 py-3.5 active:opacity-70"
      >
        <Text variant="bodyMedium">{label}</Text>
        <View className="flex-row items-center gap-2">
          {value ? (
            <RNText className="font-accent text-xs text-muted">{value}</RNText>
          ) : null}
          {right}
          {(onPress || href) && chevron ? <Chevron /> : null}
        </View>
      </Pressable>
    </Linkable>
  );
}
